import { FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "@fxid/openapi-client";
import { FxIdSdkAdapterForAbsoluteGames } from "./FxIdSdkAdapterForAbsoluteGames";
import { FxIdSdkAdapterForCrazyGames } from "./FxIdSdkAdapterForCrazyGames";
import { FxIdSdkAdapterForFacebookGames } from "./FxIdSdkAdapterForFacebookGames";
import { FxIdSdkAdapterForFacebookInstantGames } from "./FxIdSdkAdapterForFacebookInstantGames";
import { FxIdSdkAdapterForFxId } from "./FxIdSdkAdapterForFxId";
import { FxIdSdkAdapterForKongregate } from "./FxIdSdkAdapterForKongregate";
import { FxIdSdkAdapterForOk } from "./FxIdSdkAdapterForOk";
import { FxIdSdkAdapterForTelegram } from "./FxIdSdkAdapterForTelegram";
import { FxIdSdkAdapterForVkCom } from "./FxIdSdkAdapterForVkCom";
import { FxIdSdkAdapterForVkPlay } from "./FxIdSdkAdapterForVkPlay";
import { FxIdSdkAdapterForWizQ } from "./FxIdSdkAdapterForWizQ";
import { FxIdSdkAdapterForYandexGames } from "./FxIdSdkAdapterForYandexGames";
/**
 * @fileoverview Фабрика для создания экземпляров адаптеров SDK.
 * Разрывает циклическую зависимость между FxIdSdk и конкретными адаптерами.
 */
/**
 * Создает и возвращает экземпляр нужного адаптера на основе платформы.
 * @param platform - Платформа, для которой нужно создать адаптер.
 * @param exportedSdk - Экземпляр FxIdSdk для передачи в конструктор адаптера.
 * @param game - Системное имя игры.
 * @param gameConfig - Конфигурация игры.
 * @param os - Информация об операционной системе.
 * @param isMobile - Флаг, указывающий, является ли устройство мобильным.
 * @param dependencies - Зависимости для DI (UI, data, feature, analytics, i18n callbacks).
 * @returns {Promise<FxIdSdkBaseAdapter>} - Созданный экземпляр адаптера.
 */
export async function createAdapter(platform, exportedSdk, game, gameConfig, os, isMobile, dependencies) {
    log.info(`Creating adapter for ${platform}`);
    switch (platform) {
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Odnoklassniki: {
            return new FxIdSdkAdapterForOk(exportedSdk, game, gameConfig, os, isMobile, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontaktePlay: {
            return new FxIdSdkAdapterForVkPlay(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontakteCom: {
            return new FxIdSdkAdapterForVkCom(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxId: {
            return new FxIdSdkAdapterForFxId(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.YandexGames: {
            return new FxIdSdkAdapterForYandexGames(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.AbsoluteGames: {
            return new FxIdSdkAdapterForAbsoluteGames(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Kongregate: {
            return new FxIdSdkAdapterForKongregate(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FacebookGames: {
            return new FxIdSdkAdapterForFacebookGames(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FacebookInstantGames: {
            return new FxIdSdkAdapterForFacebookInstantGames(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.CrazyGames: {
            return new FxIdSdkAdapterForCrazyGames(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.WizQ: {
            return new FxIdSdkAdapterForWizQ(exportedSdk, game, gameConfig, dependencies);
        }
        case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Telegram: {
            return new FxIdSdkAdapterForTelegram(exportedSdk, game, gameConfig, dependencies);
        }
        // case FxIdDomainStoreEnumsSupportedWebPublishingPlatform.WechatMiniGame: {
        // 	return new FxIdSdkAdapterForWechat(exportedSdk, game, gameConfig, dependencies);
        // }
        default:
            throw new Error(`Unsupported adapter for ${platform}`);
    }
}
